import React from "react";
import { Page } from "components/common";
import { Row, Col, Nav } from "reactstrap";
import { HoverCard } from "components";
import img7 from '../../assets/images/users-icon.svg';
import BackButton from "components/refactoring/BackButton";


const UserPage = ({ t, getback=true }) => (
  <Page title={t("Users Settings")} className="general-settings">
    {getback && <BackButton/>}
    <hr />
    <Row>
      <Nav>
        <Col md={6}>
          <HoverCard
            imgSrc={img7}
            to="/userspage"
            title="Xero Users List"
            description="Manage your Xero Users list, review their access levels and Invite to Hesaab."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={img7}
            to="/userslist"
            title="Manage Local Users"
            description="Go through your local Hesaab users, manage their permissions and roles."
          />
        </Col>
      </Nav>
    </Row>
  </Page>
);

export default UserPage;
